import type { ApolloCache } from "@apollo/client";
import { insertIntoConnection, removeFromConnection } from "#app/lib/data/connection-cache-utils";

export function addApiKeyToCache(cache: ApolloCache, apiKey: any) {
  insertIntoConnection(cache, "apiKeys", "ApiKeyEdge", apiKey);
}

export function removeApiKeyFromCache(cache: ApolloCache, apiKeyId: string) {
  removeFromConnection(cache, "apiKeys", { __typename: "ApiKey", apiKeyId });
}
